import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { workScheduleEventListClearFilters, workScheduleEventListSetFilters } from '../../../lib/redux/actions/workScheduleEvents';
import Form from 'react-bootstrap/Form';
import UserTypeahead from '../../fields/UserTypeahead';

const mapStateToProps = (state) => ({
  ...state.userList,
});
const mapDispatchToProps = {
  workScheduleEventListSetFilters,
  workScheduleEventListClearFilters,
};

class WorkScheduleEventTableFilterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedUser: undefined,
      clearTypeaheads: false,
    };
  }

  onSubmit(values) {
    if (this.state.selectedConsultants.length) {
      values['user.id'] = this.state.selectedUser['@id'];
    }

    this.props.workScheduleEventListSetFilters(values);
  }

  clearTypeaheads() {
    this.setState(() => {
      return { clearTypeaheads: true };
    });
  }

  typeaheadCleared() {
    if (this.state.clearTypeaheads) {
      this.setState(() => {
        return { clearTypeaheads: false };
      });
    }
  }

  resetFilters() {
    const { reset, workScheduleEventListClearFilters } = this.props;
    workScheduleEventListClearFilters();
    reset();
    this.clearTypeaheads();
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="form-inline form-data-filters">
          <UserTypeahead
            shouldClear={this.state.clearTypeaheads}
            hasCleared={this.typeaheadCleared.bind(this)}
            defaultFilters={{ roles: '["ROLE_OUTSOURCER"]' }}
            multiple={false}
            label={'Outsourcer'}
            onChange={(selected) => {
              this.setState(() => {
                return { selectedUser: selected[0] };
              });
            }}
          />

          <div className="filter-actions">
            <button type="submit" className="btn btn-primary btn-sm">
              Filter
            </button>
            <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
              Reset
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'WorkScheduleEventTableFilterForm',
})(connect(mapStateToProps, mapDispatchToProps)(WorkScheduleEventTableFilterForm));
